import * as React from 'react';

function SvgLevel(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M22.5 22.5h-6V3h6v19.5zM18 21h3V4.5h-3V21zM15 22.5H9V9h6v13.5zM10.5 21h3V10.5h-3V21zM7.5 22.5h-6v-9h6v9zM3 21h3v-6H3v6z" />
    </svg>
  );
}

export default SvgLevel;
